// Utility to prevent AWS Cognito hosted UI redirects
export const preventAWSRedirects = () => {
  // Function to check and redirect away from AWS pages
  const checkAndRedirect = () => {
    const currentUrl = window.location.href;

    if (
      currentUrl.includes("signin.aws.amazon.com") ||
      currentUrl.includes("cognito") ||
      currentUrl.includes("amazonaws.com")
    ) {
      console.log("AWS redirect detected, redirecting to localhost:3000/login");
      window.location.replace("http://localhost:3000/login");
      return true;
    }
    return false;
  };

  // Check immediately
  if (checkAndRedirect()) {
    return;
  }

  // Listen for popstate events (back/forward navigation)
  window.addEventListener("popstate", checkAndRedirect);

  // Listen for beforeunload to catch any last-minute redirects
  window.addEventListener("beforeunload", (e) => {
    if (checkAndRedirect()) {
      e.preventDefault();
    }
  });

  // Periodically check URL (but only every 2 seconds to avoid performance issues)
  // This catches programmatic navigation that doesn't trigger popstate
  let lastCheckTime = Date.now();
  const checkInterval = setInterval(() => {
    const now = Date.now();
    if (now - lastCheckTime >= 2000) {
      lastCheckTime = now;
      checkAndRedirect();
    }
  }, 2000);

  // Return cleanup function
  return () => {
    clearInterval(checkInterval);
    window.removeEventListener("popstate", checkAndRedirect);
    window.removeEventListener("beforeunload", checkAndRedirect);
  };
};

// Clear all AWS-related localStorage and sessionStorage
export const clearAllAWSState = () => {
  // Clear localStorage
  try {
    Object.keys(localStorage).forEach((key) => {
      if (
        key.includes("cognito") ||
        key.includes("amplify") ||
        key.includes("aws")
      ) {
        localStorage.removeItem(key);
      }
    });
  } catch (e) { /* localStorage unavailable (sandboxed context) */ }

  // Clear sessionStorage
  try {
    Object.keys(sessionStorage).forEach((key) => {
      if (
        key.includes("cognito") ||
        key.includes("amplify") ||
        key.includes("aws")
      ) {
        sessionStorage.removeItem(key);
      }
    });
  } catch (e) { /* sessionStorage unavailable */ }

  // Clear any cookies that might be related
  try {
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      if (
        name.includes("cognito") ||
        name.includes("amplify") ||
        name.includes("aws")
      ) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      }
    });
  } catch (e) { /* cookies unavailable */ }

  console.log("All AWS state cleared");
};
